import React from 'react';
import Pictogram from '../Pictogram/Pictogram';
import { useBonusesPictogram } from './hooks';
import { getDataTestAttrs } from '../../utils/testing-locators';
import { NEW_BONUSES_PICTOGRAM } from '../../constants/dataTestIds';

const BonusesPictogram = ({ className = '' }) => {
  const isShownPictogram = useBonusesPictogram();

  return isShownPictogram ? (
    <Pictogram
      className={className}
      {...getDataTestAttrs(NEW_BONUSES_PICTOGRAM)}
    />
  ) : null;
};

export default BonusesPictogram;
